<template>
  <div class="main-box" >
    <div class="title">
    <strong  @click="$router.push('/eleWaimaiProduct')" style="cursor:pointer"><i class="el-icon-back"></i></strong>
    <span @click="test" >菜品编辑</span>
</div>
<div class="nav-menu">
  <div  class="item" title="基础信息"><a href="#baseInfo">基础信息</a></div>
  <div class="item" title="菜品构成"><a href="#saleInfo">售卖信息</a></div>
  <div class="item" title="打印配置"><a href="#high">高级信息</a></div>
</div>
<div class="main-content">
<el-row>
    <el-col><div id="baseInfo" class="base-info"><span class="line" ></span> <span>基础信息</span></div></el-col>
</el-row>
<el-form :data="form" label-width="140px">
    <el-form-item  label="菜品名称:" required>
    <el-input  v-model="form.name" style="width:320px"></el-input>
  </el-form-item>
      <el-form-item label="菜品分类:" required>
      <el-select  @change="changeSel"
      clearable value-key="categoryCode" v-model="productType" style="width:320px">
        <el-option :label="item.categoryName" :value="item" v-for="item,i in dishType" :key="i"></el-option>
      </el-select>
  </el-form-item>
      <el-form-item label="商品图片:">
        <!-- <el-upload
  class="avatar-uploader"
   :before-upload="checkImg"
  :action="$uploadURL"
  :show-file-list="false"
  :on-success="handleAvatarSuccess">
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload> -->
    <el-upload
    :on-exceed="overImg"
    :file-list="imgList"
    :limit="1"
    :before-upload="checkImg"
  :action="$uploadURL"
  list-type="picture-card"
  :on-preview="handlePictureCardPreview"
  :on-success="uploadSuccess"
  :on-remove="handleRemove">
  <i class="el-icon-plus"></i>
   <div slot="tip" class="el-upload__tip">正方形图片，尺寸大于450x450</div>
</el-upload>
<el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
  </el-form-item>
<el-row>
    <el-col><div id="saleInfo" class="base-info"><span class="line" ></span> <span>售卖信息</span></div></el-col>
</el-row>
<!-- 菜品规格 -->
  <el-form-item label="菜品规格:">
    <div style="border:1px solid #e8e8e8;margin-bottom:16px" v-for="item,i in form.specsDimAttrList" :key="i">
      <div class="dishType-head">
        <div class="left"> <span  style="font-size:17px">规格 {{i+1}}</span>
         <span v-if="item.defaultFlag==1" class="default-text">默认</span></div>
           <div class="right"
           v-if="form.specsDimAttrList.length!=1"
            @click="deleteOne(i)"><span>删除</span></div>
      </div>
     <div style="padding:14px;padding-top:8px;padding-bottom:0" class="inline-form">
       <el-form :model="item" ref="items" :inline="true" label-position="top">
        <el-form-item 
    prop="sizeName"
            :rules="{
      required: true, message: '此项必填', trigger: ['blur', 'change'] 
    }"
         label="规格名称" required>
          <el-select 
          @change="changeSel"
          v-model="item.sizeName"
           clearable value-key="dimCode" style="width:130px">
            <el-option  v-for="itemName,iName in typeName" :key="iName"
            :label="itemName.dimName"
            :value="itemName"
            ></el-option>
            <!-- <el-option value=" " ></el-option> -->
       <div style="font-size:14px;color:#ff6000;height:34px;cursor:pointer;
       display: flex;justify-content: center;align-items: center;
       position: absolute;bottom: 0;background: #fff;width: 128px"
       @click="$router.push('/merchantProductSpecification')"
       > <i style="margin-right:6px"
       class="el-icon-plus"></i><span>新建规格</span></div>
          </el-select>
        </el-form-item>
           <el-form-item 
           v-if="form.specsDimAttrList.length!=1"
           class="is-default" label="是否默认" >
          <el-radio label="1"  @change="doDefault(item,i)" v-model="item.defaultFlag">{{''}}</el-radio>
        </el-form-item>
        <el-form-item 
                    :rules="{
      required: true, message: '此项必填', trigger: ['blur', 'change'] 
    }"
         prop="normalPrice" label="基础价格" required>
         <el-input v-model="item.normalPrice" style="width:130px">
            <span slot="suffix" style="color:#333;padding-right:8px">元</span>
         </el-input>
        </el-form-item>
                <el-form-item label="会员价" >
          <el-input v-model="item.memberPrice" style="width:130px">
              <span slot="suffix" style="color:#333;padding-right:8px">元</span>
          </el-input>
        </el-form-item>
          <el-form-item label="设置餐盒" >
          <el-input style="width:90px" v-model="item.lunchBoxPrice">
             <span slot="suffix" style="color:#333;padding-right:8px">元</span>
          </el-input>
        </el-form-item>
           <el-form-item label="预估成本" >
          <el-input v-model="item.costPrice" style="width:130px">
             <span slot="suffix" style="color:#333;padding-right:8px">元</span>
          </el-input>
        </el-form-item>
           <el-form-item label="条形码 " >
          <el-input v-model="item.barCode" style="width:130px" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
     </div>
    </div>
      <div class="addOne"
      @click="addOneType"
      ><i class="el-icon-plus"></i>
      <span style="margin-left:3px">添加多个规格</span></div>
  </el-form-item>
<el-form-item label="做法:" class="text-center">
  <div class="groupByType"
  v-show="item.attrList!=null && item.attrList.length!=0"
   v-for="item,i in form.practiceDimList" :key="i">
    <div class="top">
      <div class="left">分组 {{i+1}}: <span>{{item.dimName}}</span></div>
      <div @click="deleteOneGroup(i,item.dimName)" class="right"> 删除分组</div>
    </div>
      <el-table :data="item.attrList">
    <el-table-column align="center" label="序号" type="index"></el-table-column>
     <el-table-column align="center" label="名称" prop="attrName"></el-table-column>
      <el-table-column align="center" label="价格" prop="price"></el-table-column>
        <el-table-column label="操作"  align="center">
          <template slot-scope="scope">
            <span style="cursor:pointer" 
            @click="deleteSelectCook(i,scope.$index,scope.row.attrName)">删除</span>
          </template>
        </el-table-column>
  </el-table>
  </div>
  <el-button style="margin-top:12px" class="myBtn" @click="getLeftType">添加做法</el-button>
</el-form-item>
<!-- <el-form-item label="加料:" class="text-center">
    <div class="groupByType"
     v-show="item.attrList!=null && item.attrList.length!=0"
     v-for="item,i in form.feedDimList" :key="i">
    <div class="top">
      <div class="left">分组 {{i+1}}: <span>{{item.dimName}}</span></div>
      <div  class="right" @click="doleteAddGroup(i,item.dimName)"> 删除分组</div>
    </div>
        <el-table :data="item.attrList" >
    <el-table-column align="center" label="序号" type="index"></el-table-column>
     <el-table-column align="center" label="名称" prop="attrName"></el-table-column>
      <el-table-column align="center" label="价格" prop="price"></el-table-column>
        <el-table-column label="操作"  align="center">
          <template slot-scope="scope">
            <span style="cursor:pointer" @click="deleteSelectAdd(i,scope.$index,scope.row.attrName)">删除</span>
          </template>
        </el-table-column>
  </el-table>
    </div>
  <el-button style="margin-top:12px" class="myBtn" @click="addBut()">添加加料</el-button>
</el-form-item> -->
<el-row>
    <el-col><div id="set" class="base-info"><span class="line" ></span> <span>售卖信息</span></div></el-col>
</el-row>
<!-- <el-form-item class="long-label" label="商品原料null:" required>
  <el-input v-model="form.rawMaterials" style="width:189px" placeholder="请输入"></el-input>
</el-form-item> -->
<el-form-item class="long-label seeLabel" label="商品原料:"  required>
<el-button class="myBtn" @click="rawMaterialsBtn" >添加原料</el-button>
<div class="seeName" style="color:#2f405b">
  <span style="margin-left:5px;color:#2f405b" v-for="item,i in selectMater" :key="i">{{item.name}}</span>
</div>
</el-form-item>
<el-form-item class="long-label" label="商品类目:" required>
<el-button class="myBtn" @click="categoryBtn">选择类目</el-button>
<span style="margin-left:12px;color:#2f405b" v-if="seeCategory!=''">({{seeName}})</span>
</el-form-item>
<el-form-item class="long-label" label="商品描述:" >
 <el-input
   type="textarea"
  :autosize="{ minRows: 2, maxRows: 4}"
  placeholder="200字以内，请输入"
   maxlength="200"
  v-model="form.description">
</el-input>
</el-form-item>

<el-row>
    <el-col><div id="high" class="base-info"><span class="line" ></span> <span>高级信息</span></div></el-col>
</el-row>
<el-form-item  class="long-label label-content-flex" label="最少购买:" >
 <el-input
  placeholder="最少购买"
  v-model.number="form.minPurchaseQuantity"
  > 
</el-input> <span style="margin-left:8px">个</span>
</el-form-item>
<!-- <el-form-item label="售卖时间:">
 <el-time-picker
 value-format="HH:mm:ss"
 format="HH:mm:ss"
    is-range
    v-model="dataRange"
    range-separator="至"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    placeholder="选择时间范围">
  </el-time-picker>
</el-form-item> -->
<el-form-item label="店内招牌:">
    <el-switch
  v-model="isFeatured"
  active-color="#F59A23"
  inactive-color="#DCDFE6">
</el-switch>

</el-form-item>
<el-form-item label="单点不送:">
    <el-switch
  v-model="saleAlone"
  active-color="#F59A23"
  inactive-color="#DCDFE6">
</el-switch>

</el-form-item>
</el-form>
<el-dialog
  title="做法选择"
  :visible.sync="dialogCookType"
  width="800px">
  <div class="box-main">
    <div class="left">
            <div
            @click="searchLeft('全部',-1,null)"
            :class="{'item':true,'active':leftTypeActive==-1}"
      >全部</div>
      <div
      @click="searchLeft(cook.dimName,index,cook.dimCode)"
      :class="{'item':true,'active':leftTypeActive==index}"
      v-for="cook,index in leftType" :key="index"
      >{{cook.dimName}}</div>
    </div>
    <div class="right">
      <div class="top">
        <el-input v-model="cookName" class="h32" placeholder="请输入做法名称"></el-input>
        <el-button class="h32 btn-my" style="margin-left:12px"
        @click="searchByName">
          <i style="font-size:16px;font-weight:700" class="el-icon-search"></i>
          查询</el-button>
        <el-button @click="reset"
        style="background:#fff" class="h32 btn-my">
          重置</el-button>
      </div>
      <el-table
      ref="tableRight"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
      :data="tableRight" width="100%" height="400px" style="font-size:14px;">
        <el-table-column :reserve-selection="true"   type="selection"></el-table-column>
        <el-table-column  width="60px" label="序号" type="index"></el-table-column>
        <el-table-column  label="做法名称" prop="attrName"></el-table-column>
        <el-table-column   label="变价金额" prop="price"></el-table-column>
        <el-table-column   label="做法组" prop="dimName"></el-table-column>
      </el-table>
    </div>
  </div>
    <!-- 已选项 -->
    <div style="margin-bottom:9px;color:#222;font-size:16px" v-if="selectCook.length!=0">
      <span>已选 （{{selectCook.length}}）</span>
    </div>
    <div class="hasSelect">
      <div v-for="item,i in selectCook" :key="i"
      @click="cancelSelectCook(i,item.attrCode)"
       class="item">
        {{item.attrName}} <i class="el-icon-close"></i></div>
    </div>
    <!--  -->
  <span slot="footer" class="dialog-footer">
    <div @click="goToDetailCook" class="red">新建做法</div>
    <div>
      <el-button class="btnAll btnCancel" @click="dialogCookType = false">取 消</el-button>
    <el-button class="btnAll btnSubmit" type="primary" @click="cookTypeButton">确 定</el-button>
    </div>
  </span>
</el-dialog>
<!--  -->
<el-dialog
  title="加料选择"
  :visible.sync="dialogAddMore"
  width="800px">
  <div class="box-main">
    <div class="left">
            <div
             @click="searchLeft('全部',-1,null)"
            :class="{'item':true,'active':leftTypeActive==-1}"
      >全部</div>
      <div
      @click="searchLeft(cook.dimName,index,cook.dimCode)"
      :class="{'item':true,'active':leftTypeActive==index}"
      v-for="cook,index in AddLeft" :key="index"
      >{{cook.dimName}}</div>
    </div>
    <div class="right">
      <div class="top">
        <el-input v-model="addName" class="h32" placeholder="请输入做法名称"></el-input>
        <el-button
        @click="searchByAddName"
        class="h32 btn-my" style="margin-left:12px">
          <i style="font-size:16px;font-weight:700" class="el-icon-search"></i>
          查询</el-button>
        <el-button @click="reset"
        style="background:#fff" class="h32 btn-my">
          重置</el-button>
      </div>
      <el-table
       ref="tableRight"
       :row-key="getRowKeys"
      @selection-change="handleSelectionChangeAdd"
      :data="tableRight" width="100%" height="400px" style="font-size:14px;">
        <el-table-column :reserve-selection="true"   type="selection"></el-table-column>
        <el-table-column  width="60px" label="序号" type="index"></el-table-column>
        <el-table-column  label="做法名称" prop="attrName"></el-table-column>
        <el-table-column  label="变价金额" prop="price"></el-table-column>
        <el-table-column  label="做法组" prop="dimName"></el-table-column>
      </el-table>
    </div>
  </div>
      <!-- 已选项 -->
    <div style="margin-bottom:9px;color:#222;font-size:16px" v-if="selectAdd.length!=0">
      <span>已选 （{{selectAdd.length}}）</span>
    </div>
    <div class="hasSelect">
      <div v-for="item,i in selectAdd" :key="i"
      @click="cancelSelectAdd(i,item.attrCode)"
       class="item">
        {{item.attrName}} <i class="el-icon-close"></i></div>
    </div>
    <!--  -->
  <span slot="footer" class="dialog-footer">
    <div @click="goToDetailAdd" class="red">新建加料</div>
    <div>
    <el-button class="btnAll btnCancel" @click="dialogAddMore = false">取 消</el-button>
    <el-button class="btnAll btnSubmit" @click="addButton">确 定</el-button>
 </div>
  </span>
</el-dialog>
<!--  -->
<!-- 结束new -->
</div>
<div class="foot">
       <el-button @click="$router.push('/eleWaimaiProduct')" class="btnAll btnCancel">取消</el-button>
       <el-button class="btnAll btnSubmit" @click="submit">保存并创建
      <i v-if="saveLoading" class="el-icon-loading"></i>
    </el-button>
</div>
<el-dialog
  title="商品原料"
  :visible.sync="rawMaterialsDialog"
  width="560px"
  class="myDia"
  :before-close="empty"
  >
  <div class="box-my">
    <el-form :inline="true">
      <el-form-item label="名称:">
        <el-input @keydown.native.enter="searchMaterData" clearable
        placeholder=""
         v-model="materialsInfo.condition.name" style="width:160px"></el-input>
      </el-form-item>
      <el-button style="margin-left:12px;padding:8px 15px" 
      @click="searchMaterData"
      class="myBtn">查询 
        <i class="el-icon-search"></i>
      </el-button>
    </el-form>
    <el-table height="40vh" 
    ref="materialsData"
    v-loading="materLoading"
       :row-key="row => {return row.id}"
      @selection-change="handleSelectionChangeMater" :data="materialsData">
       <el-table-column :reserve-selection="true" type="selection"></el-table-column>
      <el-table-column label="序号" type="index" align="center"></el-table-column>
      <!-- <el-table-column label="ID" prop="id" align="center"></el-table-column> -->
      <el-table-column label="名称" prop="name" align="center"></el-table-column>
      <!-- <el-table-column label="创建时间" prop="createDt" align="center"></el-table-column> -->
    </el-table>
     <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="materialsInfo.currPage"
      :page-size="materialsInfo.pageSize"
      layout="total, prev, pager, next"
      :total="materTotal">
    </el-pagination>
  </div>
        <!-- 已选项 -->
    <div style="margin-bottom:9px;color:#222;font-size:16px" v-if="selectMater!=null &&  selectMater.length!=0">
      <span >已选 （{{selectMater.length}}）</span>
    </div>
    <div class="hasSelect">
      <div v-for="item,i in selectMater" :key="i"
      @click="deleteChoice(i)"
       class="item">
        {{item.name}} <i class="el-icon-close"></i></div>
    </div>
    <!--  -->
  <span slot="footer" class="dialog-footer my">
    <el-button @click="empty">取 消</el-button>
    <el-button class="myBtn" @click="materDialogBtn">确 定</el-button>
  </span>
</el-dialog>

<el-dialog
  title="商品类目"
  :visible.sync="categoryDialog"
  width="520px">
  <div style="height:45vh;overflow:auto">
     <el-tree
  :data="treeData"
  :props="treeProps"
  label="name"
  show-checkbox
   :check-on-click-node="true" 
    :check-strictly="true" 
    @check="treeCheck"
  node-key="id"
  ref="tree"
  highlight-current
>
</el-tree>
  </div>

  <span style="display:flex;justify-content: right;" slot="footer" class="dialog-footer">
    <el-button @click="categoryDialog = false">取 消</el-button>
    <el-button style="background:#ffb100;color:#fff" @click="categoryDialogBtn">确 定</el-button>
  </span>
</el-dialog>
  </div>

</template>
<script>
export default {
  data() {
    return {
      treeProps:{
        label:'name',
        children:'children',
        id:'id'
      },
      rawMaterialsDialog:false,
      categoryDialog:false,
      treeData:[],
      seeName:'',
      seeId:null,
      seeCategory:[],
      selectMater:[],
      materLoading:true,
      materialsData:[],
        imageUrl:'',
        top:true,
        imgArr:[],
        imgList:[],//file-list
        dialogImageUrl: '',
        dialogVisible: false,
        cookName:'',
        addName:"",
        rightTableData:{
        merchantCode:"",
        dimType:'practice',
        dimCode:'',
        attrName:'',
      },
    saveLoading:false,
    dialogAddMore:false,
    selectCook:[],
    selectAdd:[],
    leftDimName:"",
    leftType:[],
    AddLeft:[],
    tableRight:[],
    leftTypeActive:-1,
    dishType:[],//菜品分类下拉框
    typeName:[],//规格名称下拉
     productType:{categoryCode:'',categoryName:'' },  //菜品分类
    dialogCookType:false,
    dataRange:'',//售卖时间
    isFeatured:false,//店内招牌
    saleAlone:false,//单点不送
    form:{
        productCode:this.$route.query.productCode,
      merchantCode:localStorage.getItem('merchantCode'),
      merchantName:localStorage.getItem('merchantName'),
       stdCategoryName:'',
       stdCategoryId:'',
      name:"",//菜品名称
      categoryCode:'',//分类编码
      categoryName:"",//  分类名称
      imageHash:'',
      imageHashs:'',//商品图片
      rawMaterials:'',//商品原料
      description:'',//商品描述
      minPurchaseQuantity:'',//最少购买
      soldTimeBegin:'',
      soldTimeEnd:'',
      isFeatured:false,//店内招牌
      saleAlone:false,//单点不送
      specsDimAttrList:[{
        sizeName:{},
        dimName:'',
        defaultFlag:'1',
        normalPrice:'',
        memberPrice:'',
        costPrice:'',
        barCode:'',
        lunchBoxPrice:''
      },
      ],
      practiceDimList:[
      ], //做法
      // practiceList:[],
      feedDimList:[
      ],//加料
      materialList:[
      ],//原料
    },
    // 原料
    materTotal:0,
    materialsInfo:{
      currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          name:''
        }
    }
    };
  },
  methods: {
    test(){
      console.log(this.form)
      console.log(this.$refs.items)
      let v=true
      this.$refs.items.forEach(el=>{
        el.validate((valid) => {
          if (valid) {
          } else {
            v=false
            console.log('error submit!!');
            return false;
          }
        });
      })
    },
    chenckValid(){
            let v=true
      this.$refs.items.forEach(el=>{
        el.validate((valid) => {
          if (valid) {

          } else {
            v=false
            console.log('error submit!!');
            return false;
          }
        });
      })
      return v
    },
    treeCheck:function(node,list){
      if (list.checkedKeys.length == 2) {
            //单选实现
            this.$refs.tree.setCheckedKeys([node.id]);
     }
},
categoryDialogBtn(){
this.categoryDialog=false
if(this.$refs.tree.getCheckedNodes()!=null && this.$refs.tree.getCheckedNodes().length!=0){
  this.seeCategory=this.$refs.tree.getCheckedNodes()[0]
  this.seeId=this.$refs.tree.getCheckedNodes()[0].id
  this.seeName=this.$refs.tree.getCheckedNodes()[0].name
}
},
    // 商品类目
  async getBackCategory(){
   let result=await   this.$http.post('/ele/getBackCategoryV2',{merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
        console.log(res,'----')
        this.treeData=res.data.data
        return res
      })
      return result
    },
  async  categoryBtn(){
      this.categoryDialog=true
      let d=await this.getBackCategory()
       this.$refs.tree.setCheckedKeys([this.seeId]);
       console.log(this.seeId)
    },
    handleSelectionChangeMater(v){
      console.log(v)
      this.selectMater=v
    },
        //清空弹窗选项
    empty () {
      this.rawMaterialsDialog=false
      this.$refs.materialsData.clearSelection()
    },
    materDialogBtn(){
      this.form.materialList=this.selectMater
      this.rawMaterialsDialog = false
    },
        //单个删除弹窗选项
    deleteChoice (index) {
      let row = this.selectMater[index]
      let rows =  this.materialsData.find(element => {
        return element.id === row.id
      })
      console.log(rows,'清空',this.selectMater)
      this.selectMater.splice(index,1)
      this.$refs.materialsData.toggleRowSelection(rows, false)
    },
        // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.materialsInfo.pageSize = newSize;
      this.getMaterData();
    },
    // 监听 页码值 改变事件
  async  handleCurrentChange(newSize) {
      this.materialsInfo.currPage = newSize;
    this.getMaterData();
    },
   async rawMaterialsBtn(){
      this.rawMaterialsDialog=true
     let d=await  this.getMaterData()
     console.log(d,'dddd')
     if(this.selectMater!=null && this.selectMater.length!=0){
      let materArr=[]
      this.materialsData.forEach(item=>{
        this.selectMater.forEach(i=>{
          if(item.id==i.id){
            materArr.push(item)
          }
        })
      })
      materArr.forEach(m=>{
        this.$refs.materialsData.toggleRowSelection(m,true)
      })
     }else{
      this.$refs.materialsData.clearSelection()
     }
    },
  async  getMaterData(){
      this.materLoading=true
     let data=await  this.$http.post('/eleMaterial/list',this.materialsInfo).then(res=>{
        console.log(res,'原料---')
        this.materTotal=res.data.data.count
        this.materialsData=res.data.data.data
        this.materLoading=false
        return res
      })
      return data
    },
    searchMaterData(){
      this.materialsInfo.currPage=1
      this.getMaterData();
    },
    overImg(file,fileList){
        // console.log(file,fileList)
        this.$message.error('已超过可选数量')
    },
    handleAvatarSuccess(res,file){
        this.form.imageHash=res.data.url
        this.imageUrl=res.data.url
        console.log(res)
    },
    uploadSuccess(res,file){
        console.log(res,file,'======')
        if(res.code==200){
            this.imgArr.push(res.data.url)
            // console.log(this.imgArr)
            // var data={}
            // data.url=res.data.url
            // data.fee=0
            // data.merchantCode=localStorage.getItem('merchantCode')
            // this.$http.post('/ele/uploadImageWithRemoteUrl',data).then(re=>{
            //   console.log(re)
            //   if(re.data.code==200){
            //     this.imgArr.push(re.data.url)
            //   }else{
            //     this.$message.error(res.data.message)
            //   }
            // })
        }
    },
    // 检查是否为png,jpeg的图片
    checkImg(file){
      console.log(file)
     const isImg = (file.type.slice(0,5) === 'image');
      const isLt1M = file.size / 1024 / 1024 < 1;
       if (!isImg) {
          this.$message.error('请上传图片');
        }
        if (!isLt1M) {
          this.$message.error('上传图片大小不能超过 1MB!');
        }
        return isImg && isLt1M
    },
       handleRemove(file, fileList) {
        console.log(file, fileList,'移除',);
        var arrImg=[]
        fileList.forEach(val=>{
            arrImg.push(val.url)
        })
        this.imgArr=arrImg
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    reset(){
      this.rightTableData.dimCode=''
      this.rightTableData.attrName=''
      this.cookName=''
      this.addName=''
      this.getRightTable()
    },
     cancelSelectAdd(i,code){
        let row=this.tableRight.find(val=>{
          return val.attrCode===code
        })
        this.$refs.tableRight.toggleRowSelection(row,false)
      },
    // 删除做法分组
    deleteOneGroup(i,dimName){
     var arr=[]
    arr= this.selectCook.filter(p=>{
      return p.dimName!=dimName
     })
    //   console.log(arr,'删选后')
      this.selectCook=arr
      this.form.practiceDimList.splice(i,1)
    },
    // 删除加料分组
    doleteAddGroup(i,dimName){
      var arr=[]
    arr= this.selectAdd.filter(p=>{
      return p.dimName!=dimName
     })
    //   console.log(arr,'删选后')
      this.selectAdd=arr
      this.form.feedDimList.splice(i,1)
    },
    // 做法选择确认按钮
    cookTypeButton(){
    // console.log(this.selectCook)
      let dataArr = [];
    this.selectCook.map(mapItem => {
      if (dataArr.length == 0) {
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
      } else {
         let res = dataArr.some(item=> {//判断
          if (item.dimName == mapItem.dimName) {
            item.attrList.push(mapItem)
            return true
          }
        })
        if (!res) {//
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
        }
      }
    })
    this.form.practiceDimList=dataArr
    //  console.log(dataArr,'66666666666',this.form.practiceDimList)
       this.dialogCookType = false
    //  获取到新数组
    },
    // 提交按钮
    submit(){
            let v=true
      this.$refs.items.forEach(el=>{
        el.validate((valid) => {
          if (valid) {
          } else {
            v=false
            console.log('error submit!!');
            return false;
          }
        });
      })
      if(!v){ 
        this.$message.error('请检查表单是否填写完毕')
        return 
      }
      this.form.categoryCode=this.productType.categoryCode
      this.form.categoryName=this.productType.categoryName
      this.form.specsDimAttrList.forEach((item,index)=>{
        item.dimName=item.sizeName.dimName
        item.dimCode=item.sizeName.dimCode
        item.attrName='规格'+ (index+1)
      })
      this.form.feedDimList.forEach(item=>{
        item.dimCode=item.attrList[0].dimCode
      })
      this.form.practiceDimList.forEach(item=>{
        item.dimCode=item.attrList[0].dimCode
      })
      if(this.dataRange==null || this.dataRange==''){
        this.form.soldTimeBegin=null
        this.form.soldTimeEnd=null
      }else{
        this.form.soldTimeBegin=this.dataRange[0]
        this.form.soldTimeEnd=this.dataRange[1]
      }
      if(this.isFeatured==true){
        this.form.isFeatured=1}else{
        this.form.isFeatured=0
      } 
      if(this.saleAlone==true){this.form.saleAlone=1}else{
        this.form.saleAlone=0
      }
      this.form.imageHash=this.imgArr[0]
      this.form.imageHashs=this.imgArr.join(',')
      if(this.seeCategory==''){
        this.$message.error('请选择类目')
        return
      }
      this.form.stdCategoryName =this.seeName
      this.form.stdCategoryId=this.seeId
      console.log(this.form,this.dataRange)
      this.saveLoading=true
      this.$http.post('eleWaimaiProduct/updateEleProduct',this.form).then(res=>{
        // console.log(res)
        if(res.data.code==200){
          this.$message({type:'success',message:'保存成功'})
          this.saveLoading=false
          this.$router.push('/eleWaimaiProduct')
        }else{
          this.$message.error(res.data.message)
           this.saveLoading=false
        }
      })
    // console.log(this.form)
    },
    deleteSelectCook(i,index,attrName){
      // this.selectCook.splice(i,1)
    //   console.log(i,index,this.form.practiceDimList,attrName,this.selectCook)
      this.form.practiceDimList[i].attrList.splice(index,1)
      // var needCook=[]
      this.selectCook.forEach((item,ItemIndex)=>{
        if(item.attrName==attrName){
          this.selectCook.splice(ItemIndex,1)
        }
      })
    //   console.log(this.selectCook,'去除后')
    },
    deleteSelectAdd(i,index,attrName){
      // console.log(i,index,this.form.practiceDimList,attrName,this.selectCook)
      this.form.feedDimList[i].attrList.splice(index,1)
      this.selectAdd.forEach((item,ItemIndex)=>{
        if(item.attrName==attrName){
          this.selectAdd.splice(ItemIndex,1)
        }
      })
    //   console.log(this.selectAdd,'去除后')
    },
    // 添加加料
 async  addBut(){
      console.log('-----')
      this.rightTableData.dimType='feed'
      this.leftTypeActive='-1'
      this.leftDimName='全部'
      this.rightTableData.dimCode=null
      this.getAddLeft()
      this.dialogAddMore=true
       this.top=false
      let re= await this.getRightTable()
      console.log(re)
        if(this.selectAdd.length!=0){
          var need=this.selectAdd
          let arrAdd=[]
        this.$refs.tableRight.clearSelection();
        this.tableRight.forEach(ele=>{
            need.forEach(item=>{
                if(ele.attrCode==item.attrCode){
                    arrAdd.push(ele)
                }
            })
        })
            arrAdd.forEach(it=>{
            console.log('回显个数',it)
            this.$refs.tableRight.toggleRowSelection(it,true);
          })
 
                }
    },
 getRowKeys(row) { //唯一值
			return row.attrCode;
			},
      // 添加加料确认按钮
    addButton(){
      this.dialogAddMore = false
      let dataArr = [];
    this.selectAdd.map(mapItem => {
      if (dataArr.length == 0) {
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
      } else {
         let res = dataArr.some(item=> {//判断相同
          if (item.dimName == mapItem.dimName) {
            item.attrList.push(mapItem)
            return true
          }
        })
        if (!res) {//如果没找相同的添加一个新对象
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
        }
      }
    })
    this.form.feedDimList=dataArr
    },
    handleSelectionChange(val){
      this.selectCook=val
      // console.log(val,'做法')
    },
    searchByName(){ //搜索
    this.rightTableData.attrName=this.cookName
    this.getRightTable()
    },
    searchByAddName(){
      this.rightTableData.attrName=this.addName
      this.getRightTable()
    },
    handleSelectionChangeAdd(val){
      this.selectAdd=val
    },
    searchLeft(dimName,index,dimCode){
      this.leftDimName=dimName
      this.leftTypeActive=index
      this.rightTableData.dimCode=dimCode
      this.getRightTable()
    },
  async getRightTable(){
    let r=await  this.$http.post('/merchantDimAttr/queryList',this.rightTableData).then( 
       res=>{
       this.tableRight = res.data.data
    //    this.$refs.tableRight.clearSelection()
       console.log('获取了table')
    //    做法回显
      })
      return r
    },
    doDefault(obj,i){
      this.form.specsDimAttrList.forEach(item=>{
        item.defaultFlag=''
      })
      this.form.specsDimAttrList[i].defaultFlag='1'
    },
    // 菜品分类下拉框
    getSelect(){
      this.$http.post('/merchantProductsCategory/queryList',{merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
        this.dishType=res.data.data
      })
    },
    // 规格名称
    getTypeName(){
      this.$http.post('/merchantDim/queryLeftMenu',{merchantCode:this.form.merchantCode,dimType:'specs'}).then(res=>{
        this.typeName=res.data.data
      })
    },
    handleClose(){
        this.$refs.tableRight.clearSelection()
        this.dialogCookType=false
        this.dialogAddMore=false
    },
  async getLeftType(){
      this.dialogCookType=true
      this.leftTypeActive='-1'
      this.leftDimName='全部'
      this.rightTableData.dimCode=null
      this.rightTableData.dimType='practice'
       this.$http.post('/merchantDim/queryLeftMenu',{merchantCode:this.form.merchantCode,dimType:'practice'}).then(res=>{
        this.leftType=res.data.data
         })
    //    this.top=true
      let t=await this.getRightTable()
      console.log(t,this.selectCook)
         if(this.selectCook.length!=0 ){
            let needs=this.selectCook
            let arr=[]
              this.$refs.tableRight.clearSelection();
            //   debugger
            //   console.log(this.tableRight,this.selectCook)
             this.tableRight.forEach(ele=>{
                needs.forEach(val=>{
                    if(ele.attrCode===val.attrCode){
                        arr.push(ele)
                        console.log(ele)
                    }
                })
            })
            arr.forEach(it=>{
            console.log('回显次数',it.attrCode,needs)
            this.$refs.tableRight.toggleRowSelection(it,true);
          })
         }else{
          this.$refs.tableRight.clearSelection()
         }
        },
      getAddLeft(){
         this.$http.post('/merchantDim/queryLeftMenu',{merchantCode:this.form.merchantCode,dimType:'feed'}).then(res=>{
          this.AddLeft=res.data.data
         })
      },
    // 添加
    addOneType(){
      console.log(this.form.specsDimAttrList)
      if(this.form.specsDimAttrList!=null && this.form.specsDimAttrList.length!=0){
        let length=this.form.specsDimAttrList.length - 1
              if(this.form.specsDimAttrList[length].normalPrice=='' ){
        return
      }
      }
      this.form.specsDimAttrList.push(
        {
        sizeName:{},
        dimName:'',
        defaultFlag:'',
        normalPrice:'',
        memberPrice:'',
        costPrice:'',
        barCode:'',
        lunchBoxPrice:''
      },
      )
    },
    // 删除
    deleteOne(i){
      console.log(this.form.specsDimAttrList,i)
      this.form.specsDimAttrList.splice(i,1)
      var flag=false
      this.form.specsDimAttrList.forEach(item=>{
        console.log(item.defaultFlag)
        if(item.defaultFlag==1){
          flag=true
          return
        }
      })
              if(flag==false){
          this.form.specsDimAttrList[0].defaultFlag='1'
        }
    },
          changeSel(val){
  this.$nextTick(() => {
    this.$forceUpdate()
    })
      },
      // 跳转做法
      goToDetailCook(){
       this.dialogCookType = false
        // this.$router.push('/merchantProductRecipes?add=true')
     let routeData = this.$router.resolve({ path: '/merchantProductRecipes', query: { add: true} });
       window.open(routeData.href, '_blank');
      },
      // 加料跳转
      goToDetailAdd(){
        this.dialogCookType = false
        // this.$router.push('/merchantProductFeedingManagement?add=true')
    let routeDatas = this.$router.resolve({ path: '/merchantProductFeedingManagement', query: { add: true} });
       window.open(routeDatas.href, '_blank');
      },
      // 
      cancelSelectCook(i,code){
        console.log(code)
        let row=this.tableRight.find(val=>{
          return val.attrCode==code
        })
        // console.log(row)
        this.$refs.tableRight.toggleRowSelection(row,false);
        // this.selectCook.splice(i,1)
        // console.log(i)
      },
    //回显
   getLoadInfo(){
      var info={}
      info.productCode=this.$route.query.productCode
      info.merchantCode=localStorage.getItem('merchantCode')
      this.$http.post('eleWaimaiProduct/queryOne',info).then( res=>{
        console.log(res,'回显')
      this.form=res.data.data
      // 
      this.selectMater=res.data.data.productMaterialList
      this.seeCategory=res.data.data.stdCategoryName
      this.seeId=res.data.data.stdCategoryId
      this.seeName=res.data.data.stdCategoryName
      this.form.materialList=res.data.data.productMaterialList
       
      // 
      this.form.productType={}
      if(res.data.data.imageHashs!=null && res.data.data.imageHashs.length!=0){
      this.form.imageHashs=res.data.data.imageHashs.split(',')
      this.imgArr=this.form.imageHashs
      this.form.imageHashs.forEach(val=>{
        this.imgList.push({url:val})
      })
      }
      this.imageUrl=res.data.data.imageHash
// 
        this.form.productType.categoryCode=res.data.data.categoryCode
        this.form.productType.categoryName=res.data.data.categoryName
        this.form.specsDimAttrList.forEach(item=>{
          item.sizeName={}
          item.sizeName.dimName=item.dimName
          item.sizeName.dimCode=item.dimCode
           console.log(item,'--------------')
        })
       var arr=[]
       res.data.data.practiceDimList.forEach(item=>{
        item.attrList.forEach(it=>{
          arr.push(it)
        })
       })
       this.selectCook=arr
       var arrs=[]
       res.data.data.feedDimList.forEach(item=>{
           item.attrList.forEach(it=>{
          arrs.push(it)
        })
       })
       this.selectAdd=arrs

       this.$set(this.productType,this.productType.categoryCode,res.data.data.categoryCode)
       this.$set(this.productType,this.productType.categoryName,res.data.data.categoryName)
        this.productType.categoryCode=res.data.data.categoryCode
        this.productType.categoryName=res.data.data.categoryName
        // this.$set(this.dataRange[0],res.data.data.soldTimeBegin)
        // this.$set(this.dataRange[1],res.data.data.soldTimeEnd)
        this.$set(this, 'dataRange', [res.data.data.soldTimeBegin, res.data.data.soldTimeEnd]);
       if(this.form.isFeatured==1){this.isFeatured=true}else{
        this.isFeatured=false
      } 
      if(this.form.saleAlone==1){this.saleAlone=true}else{
        this.saleAlone=false
      }
    //  console.log(g,'ggg',res)
    //    console.log(arr,'获取的选中项',res,this.dataRange,this.productType)
      })
    }
  },
  created() {
   this.form.merchantCode=localStorage.getItem('merchantCode')
   this.form.merchantName=localStorage.getItem('merchantName')
   this.rightTableData.merchantCode=localStorage.getItem('merchantCode')
   this.getSelect()
   this.getTypeName()
   if(this.$route.query.productCode!=='' && this.$route.query.productCode!=undefined){
    this.getLoadInfo()
   }
   
  },
  mounted() {
    // console.log(this.$route.query)
 }
};
</script>

<style lang="less" scoped>
.main-content{
    height: 65vh;
  overflow: auto;
  // margin-top: 20px;
  padding:20px;
  padding-top: 0;
      .line {
        display: inline-block;
        width: 4px;
        height: 18px;
        background-color: #ffbd00;
        margin-right: 5px;
        border-radius: 2px;
        margin-bottom: -4px;
    }
}
.main-box{
  background-color: #fff;
  padding-top: 16px;
  .nav-menu{
    padding-left: 32px;
    width: 100%;
   background-color: rgb(248,248,248);
    display: flex;
    .item{
      color: #333;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      width: 80px;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
      a{
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .item:hover{
      color: #ff6000;
    }
  }
}
.title{
   padding-left: 24px;
    height: 24px;
    margin-bottom: 24px;
    // border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span{
        margin-left: 6px;
    }
    i,span{
      font-size: 18px;
    font-weight: 500;
    color: #222;
    }
}
    .base-info{
        margin: 30px 0px 30px 20px;
    }
/deep/ .el-form-item__label{
  color: #333;
}
/deep/.inline-form{
  .el-form--inline .el-form-item{
    margin-right: 14px;
  }
  .el-form-item__label{
    padding-bottom: 0 !important;
  }
}
.default-text{
 padding:0 7px;
 color:#fff;
 background:#ffd100;
 border:1px solid #e9e9e9;
 width:24px;
 line-height:21px;
 margin-left:6px;
 font-size: 12px;
 height: 21px;
 display: inline-block;
}
/deep/ .is-default{
  .el-form-item__content{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
  .el-radio:last-child{
    margin-right: 0;
    transform: translateY(2px);
  }
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
  border-color: #ffd100;
  background-color: #ffd100;
}
/deep/ .dishType-head{
  background-color: #f7f7f7;
  display: flex;
  justify-content: space-between;
  height:32px;
  padding-left:14px;
  color:#333;
  font-weight:500;
  .left{
    display: flex;
    align-items: center;
    
  }
  .right{
    margin-right: 18px;
    color: #ff6000;
    cursor: pointer;
  }
}
.addOne{
      display: flex;
    align-items: center;
    height: 40px;
    padding: 0 16px;
    cursor: pointer;
    border-radius: 4px;
    background: #f7f7f7;
    border: 1px solid #f7f7f7;
    font-weight: 500;
    color: #ff6000;
    font-size: 14px;

}
/deep/ .myBtn{
  background-color: #ffd100;
  color: #222;
}
/deep/ .myBtn:hover{
color: #222;
}
/deep/.box-main{
  display: flex;
  .left{
    display: flex;
    flex-direction: column;
    .item{
      width: 129px;
      height: 34px;
      margin-bottom: 12px;
      padding-left: 12px;
      line-height: 34px;
      color: #333;
    }
    .item.active{
      background-color: #FFF2CC;
    }
  }
  .right{
    width: 100%;
    padding-left: 12px;
    margin-left: 6px;
    border-left: 1px solid rgba(0,0,0,.09);
    .top{
      display: flex;
      margin-bottom: 28px;
      .h32{
        height: 34px;
        font-size: 14px;
      }
      .h32.btn-my{
        background-color: #ffbd00;
        color: #000;
        padding-left: 15px;
        padding-right: 15px;
      }
      .el-input__inner{
        height: 34px !important;
      }
      .h32.el-input.el-input--small{
        width: 202px;
      }
    }
  }
}
/deep/ thead th{
  color: #333;
  font-weight: 400 !important;
}
/deep/ .el-select{
  width: 320px;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #222;
}
/deep/ .long-label{
  display: flex;
  .el-form-item__label{
    width: 144px !important;
  }
  .el-form-item__content{
    margin-left: 0 !important;
  }
}
.foot{
    display: flex;
    justify-content: right;
    height: 100px;
    background-color: #fff;
    padding-right: 60px;
    
}
/deep/ .groupByType{
  margin-block-start:14px;
  border: 1px solid #e8e8e8;
  padding-left: 8px;
  padding-right: 8px;
  color: #333;
  font-weight: 500;
  .top{
    height: 38px;
    line-height: 38px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    .left{
      font-size: 14px;
    }
    .right{
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
/deep/ .el-table-column--selection .cell{
  padding-left: 10px;
}
/deep/ .btnAll{
  background: #fff;
  color: #222;
   border:1px solid #DCDFE6;
}
/deep/ .btnCancel:hover{
  color: #222;
  border:1px solid #DCDFE6;
  
}
/deep/ .btnSubmit{
  background-color: #ffbd00;
}
/deep/ .text-center{
 label{
   transform: translateY(10px);
 }
}

/deep/ .dialog-footer{
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  .red{
    color: #ff6000;
    font-size: 14px;
    cursor: pointer;
  }
}

/deep/ .hasSelect{
  display: flex;
  height: 60px;
  overflow: auto;
  flex-wrap: wrap;
  .item{
    cursor: pointer;
    font-size: 12px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding-left: 7px;
    padding-right: 7px;
    border: 1px solid #e5e5e5;
    color: #333;
    user-select: none;
    line-height: 20px;
    height: 20px;
    background-color: #fafafa;
  }
}
/deep/ .label-content-flex{
    .el-form-item__content{
   display: flex;
    }
}

 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
  /deep/ .el-upload{
    border: 1px dashed #e5e5e5;
  }
  /deep/ .dialog-footer.my{
    justify-content: right;
  }
  /deep/ .myDia>.el-dialog .el-dialog__body{
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  /deep/ .seeName{
    width: calc(100% - 70px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /deep/ .seeLabel{
    >div{
      display: flex;
      width: calc(100% - 160px);
    }
  }
  /deep/.el-checkbox__input.is-checked{
    color:#ffbd00;
    border-color: #ffbd00 !important;
    background-color: #ffbd00 !important; 
    span{
          color:#ffbd00 !important;
    border-color: #ffbd00 !important;
    background-color: #ffbd00 !important; 
    }
  }
/deep/ ::-webkit-scrollbar-thumb,::-webkit-scrollbar-thumb{
  background: #999 !important;
  border-color: #999 !important;
}
</style>
